import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind sınıflarını çakışmasız birleştirir (shadcn/ui deseni). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
